import Template from "./template";
import BaseRoute from "../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../lib/itn-ui-kit/services/service-container";

export default class MedicalRecordsRoute extends BaseRoute {
  @service landingService;

  element = (<Template />);

  async loader({ request, params }) {
    return {};
  }
}
